module.exports = __webpack_public_path__ + "img/09.4c479f51.jpg";